import 'containers/common/Detail.css';
import OwnerOriginList from "containers/owner/OwnerOriginList";
import React, { Component } from "react";
import { Modal, Container, Row, Col } from "react-bootstrap";


export default class PropertyDetailModal extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    async componentDidMount() {
        if (!this.props.isAuthenticated) return;
        if (!this.props.show) return null;

        console.log('modal:', this.props.data);
    }

    render() {
        return (
            <Modal show={this.props.show} onHide={this.props.togglePropertyDetailModal} dialogClassName="modal-90w">
                <Modal.Header closeButton>
                    <Modal.Title>Property Detail</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Container fluid>
                        <Row>
                            <Col><strong>Property ID</strong></Col>
                            <Col xs={10}>{this.props.data.propertyId}</Col>
                        </Row>
                        <Row>
                            <Col><strong>Cityscope Reference</strong></Col>
                            <Col xs={10}>{this.props.data.cityscopeReference}</Col>
                        </Row>
                        <Row>
                            <Col><strong>Cityscope Area</strong></Col>
                            <Col xs={10}>{this.props.data.cityscopeArea}</Col>
                        </Row>
                        <Row>
                            <Col><strong>Main Street Address</strong></Col>
                            <Col xs={10}>{this.props.data.mainStreetAddress}</Col>
                        </Row>
                        <Row>
                            <Col><strong>Main Building Name</strong></Col>
                            <Col xs={10}>{this.props.data.mainBuildingName}</Col>
                        </Row>
                        <Row>
                            <Col><strong>Strata Unit Flag</strong></Col>
                            <Col xs={10}>{this.props.data.strataUnitFlag}</Col>
                        </Row>
                        <Row>
                            <Col><strong>Unit Number</strong></Col>
                            <Col xs={10}>{this.props.data.unitNumber}</Col>
                        </Row>
                        <Row>
                            <Col><strong>Main Property Type</strong></Col>
                            <Col xs={10}>{this.props.data.mainPropertyType}</Col>
                        </Row>
                        <Row>
                            <Col><strong>Building Grade</strong></Col>
                            <Col xs={10}>{this.props.data.buildingGrade}</Col>
                        </Row>
                        <Row>
                            <Col><strong>Building Area</strong></Col>
                            <Col xs={10}>{this.props.data.buildingArea}</Col>
                        </Row>
                        <Row>
                            <Col><strong>Latitude</strong></Col>
                            <Col xs={10}>{this.props.data.latitude}</Col>
                        </Row>
                        <Row>
                            <Col><strong>Longitude</strong></Col>
                            <Col xs={10}>{this.props.data.longitude}</Col>
                        </Row>
                        <Row>
                            <Col><strong>Confidence</strong></Col>
                            <Col xs={10}>{this.props.data.confidence}</Col>
                        </Row>
                    </Container>
                </Modal.Body>
            </Modal>
        );
    }
}
